import React, { createRef, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Responsive } from 'semantic-ui-react';
import Jumbotron from './components/Jumbotron';
import Gifs from './components/Gifs';
import Message from './components/Message';
import Mobile from './components/Mobile';
import Steps from './components/step/Steps';
import Tools from './components/Tools';
import Recommends from './components/recommend/Recommends';
import Form from './components/Form';
import AppStore from './components/AppStore';

export default () => {
  const [headerEmail, setHeaderEmail] = useState('');
  const anchor = createRef<HTMLDivElement>();
  const jumpTo = (email: string) => {
    setHeaderEmail(email);
    if (anchor.current) {
      anchor.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="seller-marketing" style={{ fontFamily: 'Montserrat' }}>
      <Jumbotron jumpTo={jumpTo} />
      <Gifs />
      <Responsive minWidth={640}>
        <Message />
      </Responsive>
      <Responsive maxWidth={639}>
        <Message />
      </Responsive>
      <Mobile />
      <Tools />
      <Recommends />
      <Steps />
      <div style={{ float: 'left', clear: 'both' }} ref={anchor} />
      <Form headerEmail={headerEmail} />
      <AppStore />
    </div>
  );
};
